import { render, staticRenderFns } from "./ReceiverRiskEvidenceModal.vue?vue&type=template&id=cde57a34&scoped=true"
import script from "./ReceiverRiskEvidenceModal.vue?vue&type=script&lang=js"
export * from "./ReceiverRiskEvidenceModal.vue?vue&type=script&lang=js"
import style0 from "./ReceiverRiskEvidenceModal.vue?vue&type=style&index=0&id=cde57a34&prod&scoped=true&lang=css"
import style1 from "./ReceiverRiskEvidenceModal.vue?vue&type=style&index=1&id=cde57a34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde57a34",
  null
  
)

export default component.exports